import { REPORT_ASSIGNMENT_RULES_FLAG } from './constants';

export default function canAccessAssignmentReport(
  waffleFlags = [],
  allPermissions = []
) {
  const isCompanyAdmin = allPermissions?.includes('is_company_admin');
  const hasReportFlag = waffleFlags?.includes(REPORT_ASSIGNMENT_RULES_FLAG);

  return Boolean(isCompanyAdmin && hasReportFlag);
}
